import React from 'react'
import { connect } from 'react-redux'

const mapStateToProps = (state, ownProps) => {
    return {
        agent: state.agents.find(a => a.id === Number(ownProps.params.agentId))
    }
}

const ViewAgent = ({ agent }) => {
    return (
        <div>
            <h1>View Agents</h1>
            {agent.get('firstName')}
        </div>
    )
}

export default connect(mapStateToProps)(ViewAgent)
